import { Pipe, PipeTransform } from '@angular/core';

/**
 * Used for making tab names in two line as best as possible, improvements in the future might be needed!
 */
@Pipe({
  name: 'tabBreak',
})
export class TabBreakPipe implements PipeTransform {
  transform(value: string): string {
    const words = value.split(' ');
    const split = Math.floor((words.length + 1) / 2);
    return words.slice(0, split).join(' ') + '\n' + words.slice(split);
  }
}
